import SiteLink from 'components/shared/sitelink';
import { addLocaleToHref } from 'lib/utils/helpers';
import { useRouter } from 'next/router';
import classNames from 'classnames';
import {
  FacebookIcon,
  InstagramIcon,
  LinkedInIcon,
  PinterestIcon,
  TwitterIcon,
  YouTubeIcon,
  TikTokIcon,
} from '.';
import styles from './social.module.scss';

const Social = ({ locale, links, className }) => {
  const router = useRouter();
  const getIcon = title => {
    switch (title) {
      case 'Facebook':
        return <FacebookIcon />;
      case 'Instagram':
        return <InstagramIcon />;
      case 'LinkedIn':
        return <LinkedInIcon />;
      case 'Pinterest':
        return <PinterestIcon />;
      case 'Twitter':
        return <TwitterIcon />;
      case 'YouTube':
        return <YouTubeIcon />;
      case 'TikTok':
        return <TikTokIcon />;
      default:
        return <></>;
    }
  };
  return (
    <ul className={classNames(styles.networks, className)}>
      {links.map(({ externalLink, slug, title: linkTitle }) => (
        <li key={linkTitle}>
          <SiteLink
            locale={locale}
            external={externalLink}
            href={addLocaleToHref(slug, locale, router)}
            aria-label={linkTitle} // Add descriptive aria-label
          >
            {getIcon(linkTitle)}
          </SiteLink>
        </li>
      ))}
    </ul>
  );
};

export default Social;
